import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BetSlipService {
    private sharedData: any = '';
    private parentFunction: () => void;
    private parentFunctionClear: () => void;
    private casinoParentFunction: () => void;
    private casinoParentFunctionClear: () => void;

    setSharedData(data: any) {
        this.sharedData = data;
    }

    getSharedData(): any {
        return this.sharedData;
    }

    setParentFunction(func: () => void) {
        this.parentFunction = func;
    }


    setClearBetFunction(func: () => void) {
        this.parentFunctionClear = func;
    }


    callParentFunction() {
        if (this.parentFunction) {
            this.parentFunction();
        }
    }

    callParentClearFunction() {
        if (this.parentFunctionClear) {
            this.parentFunctionClear();
        }
    }

    setCasinoParentFunction(func: () => void) {
        this.casinoParentFunction = func;
    }

    setClearCasinoBetFunction(func: () => void) {
        this.casinoParentFunctionClear = func;
    }

    callCasinoParentFunction() {
        if (this.casinoParentFunction) {
            this.casinoParentFunction();
        }
    }

    callCasinoParentClearFunction() {
        if (this.casinoParentFunctionClear) {
            this.casinoParentFunctionClear();
        }
    }

}
